// extracted by mini-css-extract-plugin
export default {"root":"ThemeProvider_root__PSLD-"};